import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

class Auth {
  constructor() {
    this.token = '';
    this.orgId = '';
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  getOrgId() {
    return this.orgId;
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async setToken(token, orgId) {
    this.token = token;
    this.orgId = orgId;
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async authCookieMirror() {
    return g_HttpReq.fetchGetJson('/auth/cookie', { action: 'mirror' });
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async authLogin(props = {}) {
    return g_HttpReq.fetchPostJson('/auth/local', props);
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async authChangeOrg(props = {}) {
    return g_HttpReq.fetchPostJson('/auth/localchangeorg', props);
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async authLoginToSub(props = {}) {
    return g_HttpReq.fetchPostJson('/auth/localtosub', props);
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async resetPassword(aUserName, aNewPassword) {
    const data = { username: aUserName, email: aUserName, newPassword: aNewPassword };
    return g_HttpReq.fetchPostJson('/auth/password', data);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async changePassword(aUserName, aNewPassword) {
    const data = { email: aUserName, newPassword: aNewPassword };
    return g_HttpReq.fetchPostJson('/auth/changepassword', data);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async setDriverPassword(props = {}) {
    return g_HttpReq.fetchPostJson('/auth/driver/setpassword', props);
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async apiDriverLogout() {
    return g_HttpReq.fetchPostJson('/auth/driver/logout', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUserLogout() {
    return g_HttpReq.fetchPostJson('/auth/logout', {});
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////
  async authForgot(props = {}) {
    return g_HttpReq.fetchPostJson('/auth/forgot', props);
  }
}

export const g_Auth = new Auth();
